"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("@package/utils");

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var validate = function validate(values) {
  var errors = {};

  if (!values['name']) {
    errors['name'] = 'Обязательное поле';
  } // eslint-disable-next-line
  else if (!/^[а-яА-ЯЁё0-9!"#$%&'()*+,\-.\\/:;<=>?@\[\]^_`{|}~]+([_\s-]?[а-яА-ЯЁё0-9!"#$%&'()*+,\-.\\/:;<=>?@\[\]^_`{|}~])*$/g.test(values['name'])) {
    errors['name'] = 'Неверный формат данных';
  }

  if (!values['email']) {
    errors['email'] = 'Обязательное поле';
  } else if (!_utils.validation.email(values['email'])) {
    errors['email'] = 'Неверный формат';
  }

  if (values['phone'] && !_utils.validation.phone(values['phone'])) {
    errors['phone'] = 'Неверный формат';
  }

  if (!values['roles'] || !values['roles'].length) {
    errors['roles'] = {
      _error: 'Обязательно к выбору'
    };
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: 'user-modify',
  enableReinitialize: true,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;